import DefaultTemplate from '@templates/DefaultTemplate';
import { Wrapper } from './QROnlyPage.styled';
import { useEffect, useRef, useState } from 'react';
import db from '@utils/db';
import { useStore } from '@store/appStore';
import { useAuthentication } from '@providers/AuthProvider';
import { useRouter } from 'next/router';
import moment from 'moment';
import QROnly from '@components/QROnly';

export const QROnlyPage = () => {
  const { client, whoIsLoggedIn, filterDate, settings } = useStore();
  
  return (
        <QROnly />
  );
};

export default QROnlyPage;
